/** Numeric and cinema alphabet rows share one distance owner. Unknown stays unknown. */
export function rowOrdinal(label: string): number | null {
	const value = label.trim().toUpperCase();
	if (/^\d+$/.test(value) && Number(value) > 0) return Number(value);
	if (/^[A-Z]{1,2}$/.test(value))
		return [...value].reduce((n, char) => n * 26 + char.charCodeAt(0) - 64, 0);
	return null;
}
